<template>
        <el-dialog
            class="issuePlatformDialog"
            title="零担订单下发确认"
            :close-on-click-modal="false"
            width="40%"
            :visible.sync="visiableDialog"
            :before-close="handleClose">
        <el-table
           :data="tableData"
           v-loading="loading"
           border
           height="150"
           style="width: 100%">
                <el-table-column
                  prop="lineName"
                  label="供应商"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="platformType"
                  label="对接平台"
                  width="155">
                </el-table-column>
                <el-table-column
                  prop="siteName"
                  label="服务平台"
                  width="160">
                </el-table-column>
                <el-table-column
                  prop="lineAccount"
                  label="专线账号"
                  width="140">
                </el-table-column>
        </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button  @click="handleClose">取 消</el-button>
                <el-button  type="primary" @click="saveOk">确 定</el-button>
            </div>
        </el-dialog>
</template>
<script>
import { sendToLtlPlatForm, getToLtlPlatFormList } from '../../../../../api/transportDetails';
export default {
    props: {
        visiableDialog: {
            type: Boolean,
            default: false
        },
        labelPosition: {
            type: String,
            default: 'right'
        },
        selected: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            tableData: [],
            loading: false
        };
    },
    methods: {
        getData() {
            let params = [];
            params = this.selected.map(item => {
                const { siteCode, carrierCode } = item;
                return {
                    siteCode,
                    carrierCode
                };
            });
            this.loading = true;
            getToLtlPlatFormList(params).then(res => {
                this.loading = false;
                if (res && +res.code === 0) {
                    this.tableData = res.data || [];
                }
            });
        },
        handleClose() {
            this.$emit('handleClose', '');
        },
        async saveOk() {
            let params = [];
            params = this.selected.map(item => {
                const { taskNo, siteCode, carrierCode } = item;
                return {
                    taskNo,
                    siteCode,
                    carrierCode
                };
            });
            await sendToLtlPlatForm(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('下发零担平台成功!');
                }
            });
            this.$emit('issuePlatformOk');
        }
    },
    created() {
        this.getData();
    }
};
</script>

<style lang="less">
.issuePlatformDialog{
    .el-dialog__body{
        padding-bottom: 0;
    }
    .el-dialog__footer{
        padding-top: 0;
    }
}
</style>